import { Notes, Head, Appear, Image } from "mdx-deck";
import gitHubDependabot from "../../../../../../images/github-dependabot.png";
import gitHubSecurityAlerts from "../../../../../../images/github-security-alerts.png";
import openPRs from "../../../../../../images/open-prs.png";
import prDetail from "../../../../../../images/pr-detail.png";
import lmcLogo from "../../../../../../images/lmc-logo.png";
import { default as customTheme } from "../../../../../../src/theme";
import React from 'react';
export default {
  Notes: Notes,
  Head: Head,
  Appear: Appear,
  Image: Image,
  gitHubDependabot: gitHubDependabot,
  gitHubSecurityAlerts: gitHubSecurityAlerts,
  openPRs: openPRs,
  prDetail: prDetail,
  lmcLogo: lmcLogo,
  customTheme: customTheme,
  React: React
};